import { Box, Grid, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Toolbar, Typography } from "@mui/material";
import axios from "axios";
import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDebounce } from "use-debounce";
import { API_BASE_URL } from "../../constants/apiConstants";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import { useMessage } from "../../context/message-context";
import { pad } from "../../functions/default";
import { useSessionStorage } from "../../utils/hooks";
import { Fehlzeitenkalender } from "../Kalender/Fehlzeitenkalender";
import { getMonthName } from "../lib";
import { NextMonthButton, NextYearButton, PreviousMonthButton, PreviousYearButton } from "../NavigationButtons/NavigationButtons";
import { PageLayout } from "../shared/components/PageComponent";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
import Tageskalender from "../Tageskalender/Tageskalender";
import Monatskalender from "./Monatskalender";

function AbsenceCalendar(props) {
  const { t } = useTranslation();
  const { client, accessToken, admin, annonym } = props;

  const [filter, setFilter] = useState("");
  const [filter2, setFilter2] = useState("");
  const [datumGrenze] = useState(new Date(new Date().setDate(new Date().getDate() - 1095)));
  const [datumGrenzeFormat] = useState(datumGrenze.getFullYear().toString() + "-" + pad(datumGrenze.getMonth() + 1, 2) + "-" + pad(datumGrenze.getDate(), 2));

  const [month, setMonth] = useState(new Date().getMonth());
  const [year, setYear] = useState(new Date().getFullYear());
  const [legende, setLegende] = useState([]);
  const [isUpdating, setIsUpdating] = useState(false);
  const { hideMessage } = useMessage();
  const [kalender, setKalender] = useState("M");
  const [open, setOpen] = useState(false);
  const [onlineId, setOnlineId] = useState("");
  const cuser = useRef("");
  const [kkst, setKkst] = useState([]);
  const [laks, setLaks] = useState([]);
  const [data, setData] = useState([]);
  const [gruppen, setGruppen] = useState([]);
  const [magruppen, setMagruppen] = useState([]);
  const [untergeben, setUntergeben] = useSessionStorage(LOCAL_STORAGE_KEY.modulGruppenfilter1);
  const [filteraktiv, setFilteraktiv] = useState("");
  const [showExcelExport, setShowExcelExport] = useState(false);
  const [jahresAnsicht, setJahresAnsicht] = useState(true);
  const [apiError, setApiError] = useState(false);
  const [currentDate, setCurrentDate] = useState("");
  const [rerender, setRerender] = useState(false);
  const [debouncedDate] = useDebounce(String(year) + pad(month, 2, "0"), 1000);
  const controller = useRef(new AbortController());
  
  const handleResults = ({ data: results }) => {
    setIsUpdating(false);
    setApiError(false);
    setCurrentDate(debouncedDate);

    if (results.users) {
      setData(results.users);
    }
    if (results.filter) {
      setFilteraktiv(results.filter);
    }
    if (results.legende) {
      setLegende(results.legende);
    }
    if (results.laks) {
      setLaks(results.laks);
    }
    if (results.kkst) {
      setKkst(results.kkst);
    }
    if (results.gruppen) {
      setGruppen(results.gruppen);
    }
    if (results.magruppen) {
      setMagruppen(results.magruppen);
    }
    if (results.excel === "J") {
      setShowExcelExport(true);
    } else {
      setShowExcelExport(false);
    }
    if (!results.hatUnterstellte) {
      setUntergeben("A");
    }
    setIsUpdating(false);
    hideMessage();
  };

  const handleResultsAdmin = ({ data: results }) => {
    getDaten(results.arbeitnehmer);
  };

  function mergeArrays(array1, array2, compare) {
    const tmparray1 = [...array1];
    const tmparray2 = [...array2];
    tmparray2.forEach((item) => {
      if (tmparray1.some((e) => e[compare] === item[compare]) === false) tmparray1.push(item);
    });
    return tmparray1;
  }

  async function getDaten(arbeitnehmer) {
    const values = await Promise.all(
      arbeitnehmer.map(async (item) => {
        return maListeLaden(item);
      })
    );

    var laks_array = [];
    var users_array = [];
    var kkst_array = [];
    var legende_array = [];
    var filter_array = [];
    var gruppen_array = [];
    var magruppen_array = [];
    var excel = "";
    var unterstellte = false;
    var tmpyear = "";
    var tmpmonth = "";

    values.forEach((item, index) => {
      if (!item) return
      if (index === 0) {
        if (item.data.laks) laks_array = [...item.data.laks];
        if (item.data.kkst) kkst_array = [...item.data.kkst];
        if (item.data.legende) legende_array = [...item.data.legende];
        if (item.data.users) users_array = [...item.data.users];
        if (item.data.gruppen) gruppen_array = [...item.data.gruppen];
        if (item.data.magruppen) magruppen_array = [...item.data.magruppen];
        excel = item.data.excel;
        unterstellte = item.data.hatUnterstellte;
        tmpyear = item.data.year;
        tmpmonth = item.data.month;
      } else {
        if (item.data.laks) laks_array = [...mergeArrays(laks_array, item.data.laks, "key")];
        if (item.data.kkst) kkst_array = [...mergeArrays(kkst_array, item.data.kkst, "key")];
        if (item.data.legende) legende_array = [...mergeArrays(legende_array, item.data.legende, "key")];
        if (item.data.users) users_array = [...mergeArrays(users_array, item.data.users, "vkey")];
        if (item.data.gruppen) gruppen_array = [...mergeArrays(gruppen_array, item.data.gruppen, "key")];
        if (item.data.magruppen) magruppen_array = [...mergeArrays(magruppen_array, item.data.magruppen, "key")];
      }
    });

    setIsUpdating(false);
    setApiError(false);
    setCurrentDate(debouncedDate);

    if (users_array) {
      setData(users_array);
    }
    if (filter_array) {
      setFilteraktiv(filter_array);
    }
    if (legende_array) {
      setLegende(legende_array);
    }
    if (laks_array) {
      setLaks(laks_array);
    }
    if (kkst_array) {
      setKkst(kkst_array);
    }
    if (gruppen_array) {
      setGruppen(gruppen_array);
    }
    if (magruppen_array) {
      setMagruppen(magruppen_array);
    }
    if (excel === "J") {
      setShowExcelExport(true);
    } else {
      setShowExcelExport(false);
    }
    if (unterstellte) {
      setUntergeben("A");
    }
    setIsUpdating(false);
    hideMessage();

    return values;
  }

  
  const maListeLaden = async (arbeitnehmer) => {
    
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: annonym?"PMABW3":admin?"PMABW2":"",
      statement: "MA_LADEN",
      maliste: arbeitnehmer.liste,
      month: month + 1,
      year: year,
      untergeben: untergeben,
    };
    return await apiDataRequest(payload, headers).then({}).catch(handleError);
  };

  const apiDataRequest = (payload, headers) => {
    return axios.post(API_BASE_URL + "daten", payload, {
      withCredentials: true,
      headers: headers,
      signal: controller.current.signal,
    });
  };

  const handleError = (error) => {
    console.log(error);
    if (error.code !== "ERR_CANCELED") {
      setApiError(true);
      setIsUpdating(false);
    }
  };

  const ladeAbwesenheitsKalender = useCallback(() => {
    if (controller.current && typeof controller.current.abort === "function") {
      controller.current.abort();
    }
    setIsUpdating(true);
    controller.current = new AbortController();
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: admin ? "PMABW2" : annonym ? "PMABW3" : "PMABWU",
      statement: "LADEN_NEU",
      month: month + 1,
      year: year,
      untergeben: untergeben,
    };
    apiDataRequest(payload, headers).then(handleResults).catch(handleError);

    return () => {
      controller.current.abort();
    };
  }, [client, admin, annonym, month, year, untergeben, debouncedDate]);

  const ladeAbwesenheitsKalenderAdmin = useCallback(() => {
    if (controller.current && typeof controller.current.abort === "function") {
      controller.current.abort();
    }
    setIsUpdating(true);
    controller.current = new AbortController();
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: "PMABW2",
      statement: "HOLE_AN",
      month: month + 1,
      year: year,
      untergeben: untergeben,
    };
    apiDataRequest(payload, headers).then(handleResultsAdmin).catch(handleError);

    return () => {
      controller.current.abort();
    };
  }, [client, admin, annonym, month, year, untergeben, debouncedDate]);

  const ladeAbwesenheitsKalenderAnnonym = useCallback(() => {
    if (controller.current && typeof controller.current.abort === "function") {
      controller.current.abort();
    }
    setIsUpdating(true);
    controller.current = new AbortController();
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: "PMABW3",
      statement: "HOLE_AN",
      month: month + 1,
      year: year,
      untergeben: untergeben,
    };
    apiDataRequest(payload, headers).then(handleResultsAdmin).catch(handleError);

    return () => {
      controller.current.abort();
    };
  }, [client, admin, annonym, month, year, untergeben, debouncedDate]);

  useEffect(() => {
    if (!rerender) return;
    setRerender(false);
    if (admin) {
      ladeAbwesenheitsKalenderAdmin();
    } else {
      if (annonym){
      ladeAbwesenheitsKalenderAnnonym();
      } else {
        ladeAbwesenheitsKalender();
      }
    }
  }, [rerender,month]);

  useEffect(() => {
    if (debouncedDate === currentDate) return; // wenn der aktuelle Monat schon geladen ist, dann müssen wir nicht erneut laden ...
    if (!rerender) setRerender(true);
  }, [currentDate, debouncedDate]);

  useEffect(() => {
    if (untergeben === "") {
      setUntergeben("D");
    }
    if (!rerender) setRerender(true);
  }, [untergeben]);

  const nextMonth = () => {
    let newYear;
    let newMonth;
    controller.current.abort();
    setIsUpdating(true);
    if (month === 11) {
      newYear = year + 1;
      newMonth = 0;
    } else {
      newYear = year;
      newMonth = month + 1;
    }
    setMonth(newMonth);
    setYear(newYear);
    if (currentDate === String(newYear) + String(newMonth)) {
      setIsUpdating(false);
    } else {
      setIsUpdating(true);
    }
  };

  const previousMonth = () => {
    let newYear;
    let newMonth;
    controller.current.abort();
    if (month === 0) {
      newYear = year - 1;
      newMonth = 11;
    } else {
      newYear = year;
      newMonth = month - 1;
    }

    if (newYear.toString() + pad((newMonth + 1).toString(), 2) < datumGrenzeFormat.replace(/-/g, "").substring(0, 6)) {
      return;
    }
    setMonth(newMonth);
    setYear(newYear);
    if (currentDate === String(newYear) + String(newMonth)) {
      setIsUpdating(false);
    } else {
      setIsUpdating(true);
    }
  };
  const nextYear = () => {
    controller.current.abort();
    setIsUpdating(true);
    setYear(year + 1);
    if (currentDate === String(year + 1) + String(month)) {
      setIsUpdating(false);
    } else {
      setIsUpdating(true);
    }
  };
  const previousYear = () => {
    controller.current.abort();
    let newMonth = month;
    let newYear;
    setIsUpdating(true);
    if ((year - 1).toString() + pad(month.toString(), 2) < datumGrenzeFormat.replace(/-/g, "")) {
      newMonth = parseInt(datumGrenze.getMonth());
      newYear = parseInt(datumGrenzeFormat.toString().substring(0, 4));
    } else {
      newYear = year - 1;
    }

    setMonth(newMonth);
    setYear(newYear);
    if (currentDate === String(newYear) + String(newMonth)) {
      setIsUpdating(false);
    } else {
      setIsUpdating(true);
    }
  };
  const checkYear = (year) => {
    if ((year - 1).toString() < datumGrenzeFormat.replace(/-/g, "").substring(0, 4)) {
      return;
    }
    setYear(year);
  };

  function Auswahl(id, name) {
    setOnlineId(id);
    cuser.current = name;
    setOpen(false);
    setKalender("J");
  }

  const handleJahresAnsichtChange = (newValue) => {
    setJahresAnsicht(newValue);
  };

  const handleKalenderAnsichtChange = (event) => {
    if (event.target.value === "J") {
      setOpen(true);
    }
    setKalender(event.target.value);
  };

  return (
    <PageLayout
      header={
        <Box p={1}>
          <Grid container justifyContent="center" spacing={1}>
            <Grid item xs={12}>
              <Select size="small" fullWidth onChange={handleKalenderAnsichtChange} value={kalender}>
                <MenuItem value={"J"}>{t("Jahreskalender")}</MenuItem>
                <MenuItem value={"M"}>{t("Monatskalender")}</MenuItem>
                <MenuItem value={"T"}>{t("Tageskalender")}</MenuItem>
              </Select>
            </Grid>
          </Grid>
        </Box>
      }
      content={
        <>
          <ResponsiveDialog
            title={t("Mitarbeiterauswahl")}
            open={open}
            setOpen={() => {
              setOpen(false);
              if (onlineId === "") {
                setKalender("M");
              }
            }}
          >
            <Box p={2}>
              <TextField
                fullWidth
                label={t("Suche")}
                id="filter2"
                variant="outlined"
                value={filter2}
                inputProps={{
                  autoCapitalize: "off",
                  autoCorrect: "off",
                  spellCheck: "false",
                  autoComplete: "off",
                }}
                onChange={(e) => setFilter2(e.target.value)}
              />
            </Box>
            <TableContainer>
              <Table>
                <TableBody>
                  {data &&
                    data.length > 0 &&
                    data
                      .filter((item) => item.name?.toLowerCase().includes(filter2?.toLowerCase()))
                      .map((item) => {
                        return (
                          <TableRow style={{ cursor: "pointer" }} onClick={() => Auswahl(item.oid, item.name)} hover key={item.oid}>
                            <TableCell>{item.name}</TableCell>
                          </TableRow>
                        );
                      })}
                </TableBody>
              </Table>
            </TableContainer>
          </ResponsiveDialog>
          {kalender === "M" && (
            <Monatskalender
              month={month}
              year={year}
              isLoading={isUpdating}
              people={data}
              legende={legende}
              showExcelExport={showExcelExport}
              modulGruppenFilter={filteraktiv}
              onPreviousYearClick={previousYear}
              onPreviousMonthClick={previousMonth}
              onNextYearClick={nextYear}
              onNextMonthClick={nextMonth}
              kkst={kkst}
              laks={laks}
              gruppen={gruppen}
              magruppen={magruppen}
              admin={admin}
              annonym={annonym}
              isError={apiError}
              filter={filter}
              setFilter={setFilter}
              untergeben={untergeben}
              setUntergeben={setUntergeben}
            />
          )}
          {kalender === "J" && (
            <Box p={2}>
              <Grid container justifyContent="center" spacing={2}>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <Box p={2}>
                    <Select fullWidth value={onlineId} open={false} onOpen={() => setOpen(true)}>
                      {data.map((item) => (
                        <MenuItem value={item.oid}>{item.name}</MenuItem>
                      ))}
                    </Select>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Toolbar>
                    <PreviousYearButton onClick={() => checkYear(year - 1)} />
                    {!jahresAnsicht && <PreviousMonthButton onClick={previousMonth} />}
                    <Box style={{ flexGrow: 1 }}></Box>
                    <Box pt={1.3}>
                      <Typography>{jahresAnsicht ? t("Jahr") + " " + year : t(getMonthName(month)) + " " + year}</Typography>
                    </Box>
                    <Box style={{ flexGrow: 1 }}></Box>
                    {!jahresAnsicht && <NextMonthButton onClick={nextMonth} />}
                    <NextYearButton onClick={() => setYear(year + 1)} />
                  </Toolbar>
                </Grid>
                <Grid item xs={12}>
                  <Fehlzeitenkalender
                    client={client}
                    accessToken={accessToken}
                    onlineid={onlineId}
                    jahresAnsicht={jahresAnsicht}
                    onJahresAnsichtChange={handleJahresAnsichtChange}
                    year={year}
                    setYear={setYear}
                    month={month}
                    setMonth={setMonth}
                  />
                </Grid>
              </Grid>
            </Box>
          )}
          {kalender === "T" && <Tageskalender client={client} accessToken={accessToken} />}
        </>
      }
    />
  );
}
export default AbsenceCalendar;
